import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-white border-t border-brand-border" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <img
              src="/logo.png"
              alt="Career Connect"
              className="h-16 w-16 object-contain"
              data-testid="footer-logo"
            />
            <div className="leading-tight">
              <div className="font-heading text-xl font-semibold">Career Connect</div>
              <div className="mt-0.5 text-[9px] tracking-[0.08em] uppercase text-brand-muted font-semibold text-center">
                Right People at Right Place
              </div>
            </div>
          </div>
          <p className="mt-5 text-sm text-brand-muted max-w-md leading-relaxed">
            A people-first HR consultancy founded in 2026 by Priyanka Khasnis, based in
            Pune. We help startups and growing companies hire the right talent — and
            help candidates build meaningful careers.
          </p>

          <ul className="mt-6 space-y-2 text-sm text-brand-muted">
            <li className="flex items-center gap-2">
              <MapPin size={14} className="text-brand-primary" />
              Parvati, Pune – 411009, Maharashtra, India
            </li>
            <li className="flex items-center gap-2">
              <Mail size={14} className="text-brand-primary" />
              <a className="hover:text-brand-ink" href="mailto:hiring.careerconnect@gmail.com">
                hiring.careerconnect@gmail.com
              </a>
            </li>
            <li className="flex items-center gap-2">
              <Phone size={14} className="text-brand-primary" />
              <a className="hover:text-brand-ink" href="tel:+917774805226">
                +91 77748 05226
              </a>
            </li>
          </ul>
        </div>

        <div>
          <div className="text-sm font-semibold text-brand-ink">For Companies</div>
          <ul className="mt-4 space-y-2 text-sm text-brand-muted">
            <li><a href="#for-companies" className="hover:text-brand-ink">Recruitment</a></li>
            <li><a href="#for-companies" className="hover:text-brand-ink">Startup HR Setup</a></li>
            <li><a href="#for-companies" className="hover:text-brand-ink">HR Retainer</a></li>
            <li><a href="#for-companies" className="hover:text-brand-ink">Bulk Hiring</a></li>
          </ul>
        </div>

        <div>
          <div className="text-sm font-semibold text-brand-ink">For Candidates</div>
          <ul className="mt-4 space-y-2 text-sm text-brand-muted">
            <li><a href="#for-candidates" className="hover:text-brand-ink">CV Building</a></li>
            <li><a href="#for-candidates" className="hover:text-brand-ink">Interview Prep</a></li>
            <li><a href="#for-candidates" className="hover:text-brand-ink">Career Guidance</a></li>
            <li><a href="#contact" className="hover:text-brand-ink">Contact</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-brand-border">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-brand-muted">
          <p>© {new Date().getFullYear()} Career Connect. All rights reserved.</p>
          <div className="flex items-center gap-4 flex-wrap justify-center">
            <Link to="/privacy" className="hover:text-brand-ink" data-testid="footer-privacy-link">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-brand-ink" data-testid="footer-terms-link">
              Terms & Conditions
            </Link>
            <Link to="/admin/login" className="hover:text-brand-ink" data-testid="footer-admin-link">
              Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
